import React, { useState } from "react";
import "./styles.css";
import { connect } from "react-redux";
import { createStructuredSelector } from "../../../../node_modules/reselect/es/index";
import { setData } from "ducks/actions/index";
import { makeSelectAccountBillingDetails, makeSelectAccountSecondaryDetails, makeSelectBillingEmailCompleted, makeSelectEnableSimCountNextButton, makeSelectIsSecondaryDetailsCompleted, makeSelectSimCountNewAndTransfer } from "ducks/selectors/planService";

const BillingDetails = ({
  initialEmail = "",
  onChange,
  onBlur,
  setAccountBillingDetails,
  accountBillingDetails,
  setBillingEmailCompleted
}) => {
  const [email, setEmail] = useState(accountBillingDetails);
  const [error, setError] = useState("");

  const isValidEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    setAccountBillingDetails(value);
    
    const isEmailValid = isValidEmail(value);
    
    if (!value.trim()) {
      setError("Please fill in your email address");
    } else if (!isEmailValid) {
      setError("Please enter a valid email address");
    } else {
      setError("");
    }

    if (isEmailValid) {
      setBillingEmailCompleted(true);
    } else {
      setBillingEmailCompleted(false);
    }
  };

  return (
    <div className="billing-details-container">
      <h2 className="billing-details-title">Billing details</h2>
      <p className="billing-details-desc">
        We'll send your monthly bills to this email address.
      </p>

      <div className="form-group full-width">
        <label htmlFor="billing_email" className="form-label">
          Billing email address
        </label>
        <input
          type="email"
          id="billing_email"
          name="billing_email"
          className={`form-input ${error ? "form-input-error" : ""}`}
          value={email}
          onChange={handleEmailChange}
          onBlur={onBlur}
          placeholder="user@company.com"
          required
        />
        {error && (
          <div className="form-error">
            {error}
          </div>
        )}
      </div>
    </div>
  );
};

export function mapDispatchToProps(dispatch) {
  return {
    setAccountBillingDetails: (accountBillingDetails) =>{
      console.log("ACCOUNT billing DETAILS", accountBillingDetails)
      dispatch(
        setData({
          key: "accountBillingDetails",
          data: {
             billing_email: accountBillingDetails
          }
        })
      );
    },
    setBillingEmailCompleted: (isBillingEmailCompleted) => {
      console.log("setBillingEmailCompleted",isBillingEmailCompleted )
      dispatch(
        setData({
          key: "isBillingEmailCompleted",
          data: {isBillingEmailCompleted} 
        })
      );
    }
  }
}

const mapStateToProps = createStructuredSelector({
  simCounts: makeSelectSimCountNewAndTransfer(),
  enableSimCountNextBtn: makeSelectEnableSimCountNextButton(),
  accountSecondaryDetails: makeSelectAccountSecondaryDetails(),
  isSecondaryDetailsCompleted: makeSelectIsSecondaryDetailsCompleted(),
  accountBillingDetails: makeSelectAccountBillingDetails(),
  isBillingEmailCompleted: makeSelectBillingEmailCompleted()
});

export default connect(mapStateToProps,mapDispatchToProps)(BillingDetails);
